import React, { useState, useEffect, useContext } from "react";
import Slider from "react-slick";
import SidebarContext from "../../contexts/MyContext";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Component for displaying stars based on rating
const StarRating = ({ rating }) => {

    const totalStars = 5; // Max stars
    return (
        <div style={{}}>
            {[...Array(totalStars)].map((_, index) => (
                <span key={index} style={{ color: index < rating ? "#FFD700" : "#D1D5DB" }}>
                    ★
                </span>

            ))}
        </div>
    );
};

const UserReviews = () => {
    const { userReviews } = useContext(SidebarContext);




    // Settings for React-Slick Carousel
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div style={{ padding: "60px 0", overflow: "hidden" }}>
            <h3 className="text-center" style={{ marginBottom: "30px" }}>
                What People Say About Voice Recorder
            </h3>
            <Slider {...settings}>
                {userReviews.map((review, index) => (
                    <div key={index} style={{ padding: "0px 15px" }}> {/* Added spacing */}
                        <div
                            style={{
                                background: "#F1F5F9",
                                padding: "40px 20px",
                                borderRadius: "10px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                minHeight: "300px",
                                textAlign: "center",
                                width: "95%"
                            }}
                        >
                            <span style={{ color: "#94A3B8", textAlign: "left", fontWeight: "500" }}>
                                {review.name || "Anonymous"}
                            </span>
                            <div className="d-flex justify-content-center">
                                <img
                                    src={
                                        review?.rating === 5
                                            ? "/img/rating5.png"
                                            : review?.rating === 4.5
                                                ? "/img/rating4.5.png"
                                                : review?.rating === 4
                                                    ? "/img/rating4.png"
                                                    : "/img/rating5.png"
                                    }

                                    alt="rating"
                                    style={{

                                        width: "212px",
                                        height: "36px",
                                    }}
                                />
                                {/* <StarRating rating={review?.rating} /> */}
                            </div>
                            <h6
                                style={{
                                    margin: "0",
                                    fontWeight: "500",
                                    fontFamily: "Metropolis",
                                    fontSize: "24px",
                                    letterSpacing: "-1px",
                                    fontWeight: "500"
                                }}
                            >
                                {`"${review.title || "Great app"}"`}
                            </h6>
                            <p
                                style={{
                                    fontFamily: "Inter",
                                    fontWeight: "400",
                                    fontStyle: "italic",
                                    fontSize: "16px",
                                    fontWeight: "400"
                                    // marginTop: "auto", // Push to bottom if content is less
                                }}
                            >
                                {review.description || "No description provided."}
                            </p>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default UserReviews;
